import { VaultPendingFilesUploadingModalFooter, VaultPendingFilesUploadingModalFooterButton } from "./VaultPendingFilesModal.styles";
import { LoadingOutlined } from "@ant-design/icons";

export const UploadingModalFooter = ({ onSubmit, isDeleting, isLoading, isButtonDisabled }) => (
    <VaultPendingFilesUploadingModalFooter>
        <VaultPendingFilesUploadingModalFooterButton
            onClick={onSubmit}
            isDeleting={isDeleting}
            isButtonDisabled={isButtonDisabled}
        >
            {isLoading ? <LoadingOutlined /> : "Submit files"}
        </VaultPendingFilesUploadingModalFooterButton>
    </VaultPendingFilesUploadingModalFooter>
);